import api from 'api/axios';
import { AddedMember, CompanyRegisterData } from 'types/api';
import { RegisterUserData } from 'types/register';
const registerModuleApi = {
  addMember: async (member: Partial<AddedMember>) => {
    try {
      const response = await api.post('workspace/members/', member);
      return response.data as AddedMember;
    } catch (error) {
      throw error;
    }
  },

  deleteMember: async (id: number) => {
    try {
      await api.delete(`workspace/members/${id}/`);
    } catch (error) {
      throw error;
    }
  },

  updateMember: async (id: number, member: Partial<AddedMember>) => {
    try {
      const response = await api.put(`workspace/members/${id}/`, member);
      return response.data as AddedMember;
    } catch (error) {
      throw error;
    }
  },

  registerCompany: async (company: CompanyRegisterData) => {
    try {
      await api.post('users/company/', company);
    } catch (error) {
      throw error;
    }
  },

  registerUser: async (user: RegisterUserData) => {
    try {
      await api.post('users/auth/register/', user);
    } catch (error) {
      throw error;
    }
  },

  validateToken: async (invite_uuid: string) => {
    try {
      const { data } = await api.post('users/auth/verify_invite/', {
        invite_uuid,
      });
      return data.is_valid as boolean;
    } catch (error) {
      throw error;
    }
  },
};
export { registerModuleApi };
